import {
  createActions,
  handleActions
} from 'redux-actions';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

const ETH_NETWORK = {
  '1': 'Mainnet',
  '4': 'Rinkeby',
  '5777': 'Ganache',
};
const FEEDBAG_URLS = {
  '1': '/feedbag', // Mainnet - proxy to now
  '4': '/feedbag-staging', // Rinkeby - proxy to now
  '5777': 'http://localhost:3001', // Ganache
};
const IPFS_URLS = {
  '1': 'https://ipfs.wwworldcup.com', // Mainnet
  '4': 'https://ipfs.wwworldcup.com', // Rinkeby
  '5777': 'http://localhost:5002', // Ganache
};
const TEAM_COLORS = {
  "peru": "C4070F",
  "argentina": "A2DBE6",
  "australia": "FFD565",
  "belgium": "DEA06F",
  "brazil": "FDD049",
  "colombia": "FBF67F",
  "costa-rica": "D95155",
  "croatia": "D21923",
  "denmark": "CB2D2E",
  "egypt": "1D2120",
  "england": "304B8C",
  "france": "112F53",
  "germany": "147786",
  "iceland": "202EC2",
  "iran": "DD5B5B",
  "japan": "1C316D",
  "mexico": "49D1B2",
  "nigeria": "65CD80",
  "morocco": "D52322",
  "panama": "8B1521",
  "poland": "E8304B",
  "russia": "9EB183",
  "saudi-arabia": "429655",
  "senegal": "67C5BB",
  "serbia": "F14643",
  "south-korea": "222C43",
  "spain": "971C18",
  "sweden": "0E47AE",
  "switzerland": "D7313D",
  "tunisia": "B41B2D",
  "uruguay": "8FD2FB",
  "portugal": "AC3E4E",
};

export const {

  loadWeb3Start,
  loadWeb3Success,
  loadWeb3Error,

  loadWeb3AccountsStart,
  loadWeb3AccountsSuccess,
  loadWeb3AccountsError,

  updateBlockNumberStart,
  updateBlockNumberSuccess,
  updateBlockNumberError,

  loadNetworksStart,
  loadNetworksSuccess,
  loadNetworksError,

  tokenGetNameStart,
  tokenGetNameSuccess,
  tokenGetNameError,

  tokenGetSymbolStart,
  tokenGetSymbolSuccess,
  tokenGetSymbolError,

  tokenGetMetadataStart,
  tokenGetMetadataSuccess,
  tokenGetMetadataError,

  tokenGetMetadataPathStart,
  tokenGetMetadataPathSuccess,
  tokenGetMetadataPathError,

  tokenGetMetadataManifestStart,
  tokenGetMetadataManifestSuccess,
  tokenGetMetadataManifestError,

  tokenWithdrawBalanceStart,
  tokenWithdrawBalanceSuccess,
  tokenWithdrawBalanceError,

  legendaryAuctionCreateStart,
  legendaryAuctionCreateSuccess,
  legendaryAuctionCreateError,

  rareAuctionCreateStart,
  rareAuctionCreateSuccess,
  rareAuctionCreateError,

  commonAuctionCreateStart,
  commonAuctionCreateSuccess,
  commonAuctionCreateError,

  reindexAuctionsStart,
  reindexAuctionsSuccess,
  reindexAuctionsError,

  reindexLiveAuctionsStart,
  reindexLiveAuctionsSuccess,
  reindexLiveAuctionsError,

  auctionsGetLiveStart,
  auctionsGetLiveSuccess,
  auctionsGetLiveError,

  pollAuctionsGetLiveStart,
  pollAuctionsGetLiveSuccess,
  pollAuctionsGetLiveError,

  auctionsGetAllStart,
  auctionsGetAllSuccess,
  auctionsGetAllError,

  pollAuctionsGetAllStart,
  pollAuctionsGetAllSuccess,
  pollAuctionsGetAllError,

  myAuctionsGetStart,
  myAuctionsGetSuccess,
  myAuctionsGetError,

  pollMyAuctionsGetStart,
  pollMyAuctionsGetSuccess,
  pollMyAuctionsGetError,

  bidOnAuctionStart,
  bidOnAuctionSuccess,
  bidOnAuctionError,

  auctionFinalizeStart,
  auctionFinalizeSuccess,
  auctionFinalizeError,

  myTeamsGetStart,
  myTeamsGetSuccess,
  myTeamsGetError,

  pollMyTeamsGetStart,
  pollMyTeamsGetSuccess,
  pollMyTeamsGetError,

  getUnclaimedBidsByAuctionIndexByBidderStart,
  getUnclaimedBidsByAuctionIndexByBidderSuccess,
  getUnclaimedBidsByAuctionIndexByBidderError,

  unclaimedBidsGetAllStart,
  unclaimedBidsGetAllSuccess,
  unclaimedBidsGetAllError,

  pollUnclaimedBidsGetAllStart,
  pollUnclaimedBidsGetAllSuccess,
  pollUnclaimedBidsGetAllError,

  returnBidsStart,
  returnBidsSuccess,
  returnBidsError,

} = createActions({

  'LOAD_WEB3_START': undefined,
  'LOAD_WEB3_SUCCESS': (web3) => ({ web3 }),
  'LOAD_WEB3_ERROR': (error) => ({ error }),

  'LOAD_WEB3_ACCOUNTS_START': undefined,
  'LOAD_WEB3_ACCOUNTS_SUCCESS': (accounts) => ({ accounts }),
  'LOAD_WEB3_ACCOUNTS_ERROR': (error) => ({ error }),

  'UPDATE_BLOCK_NUMBER_START': undefined,
  'UPDATE_BLOCK_NUMBER_SUCCESS': (blockNumber) => ({ blockNumber }),
  'UPDATE_BLOCK_NUMBER_ERROR': (error) => ({ error }),

  'LOAD_NETWORKS_START': undefined,
  'LOAD_NETWORKS_SUCCESS': (netId) => ({ netId }),
  'LOAD_NETWORKS_ERROR': (error) => ({ error }),

  'TOKEN_GET_NAME_START': undefined,
  'TOKEN_GET_NAME_SUCCESS': undefined,
  'TOKEN_GET_NAME_ERROR': (error) => ({ error }),

  'TOKEN_GET_SYMBOL_START': undefined,
  'TOKEN_GET_SYMBOL_SUCCESS': undefined,
  'TOKEN_GET_SYMBOL_ERROR': (error) => ({ error }),

  'TOKEN_GET_METADATA_START': undefined,
  'TOKEN_GET_METADATA_SUCCESS': (path, data) => ({ path, data }),
  'TOKEN_GET_METADATA_ERROR': (path, error) => ({ error }),

  'TOKEN_GET_METADATA_PATH_START': undefined,
  'TOKEN_GET_METADATA_PATH_SUCCESS': (resp) => ({ resp }),
  'TOKEN_GET_METADATA_PATH_ERROR': (error) => ({ error }),

  'TOKEN_GET_METADATA_MANIFEST_START': undefined,
  'TOKEN_GET_METADATA_MANIFEST_SUCCESS': (path, data) => ({ path, data }),
  'TOKEN_GET_METADATA_MANIFEST_ERROR': (error) => ({ error }),

  'TOKEN_WITHDRAW_BALANCE_START': undefined,
  'TOKEN_WITHDRAW_BALANCE_SUCCESS': (path, data) => ({ path, data }),
  'TOKEN_WITHDRAW_BALANCE_ERROR': (error) => ({ error }),

  'LEGENDARY_AUCTION_CREATE_START': undefined,
  'LEGENDARY_AUCTION_CREATE_SUCCESS': (resp) => ({ resp }),
  'LEGENDARY_AUCTION_CREATE_ERROR': (error) => ({ error }),

  'RARE_AUCTION_CREATE_START': undefined,
  'RARE_AUCTION_CREATE_SUCCESS': (resp) => ({ resp }),
  'RARE_AUCTION_CREATE_ERROR': (error) => ({ error }),

  'COMMON_AUCTION_CREATE_START': undefined,
  'COMMON_AUCTION_CREATE_SUCCESS': (resp) => ({ resp }),
  'COMMON_AUCTION_CREATE_ERROR': (error) => ({ error }),

  'REINDEX_AUCTIONS_START': undefined,
  'REINDEX_AUCTIONS_SUCCESS': (data) => ({ data }),
  'REINDEX_AUCTIONS_ERROR': (error) => ({ error }),

  'REINDEX_LIVE_AUCTIONS_START': undefined,
  'REINDEX_LIVE_AUCTIONS_SUCCESS': (data) => ({ data }),
  'REINDEX_LIVE_AUCTIONS_ERROR': (error) => ({ error }),

  'AUCTIONS_GET_LIVE_START': undefined,
  'AUCTIONS_GET_LIVE_SUCCESS': (data) => ({ data }),
  'AUCTIONS_GET_LIVE_ERROR': (error) => ({ error }),

  'POLL_AUCTIONS_GET_LIVE_START': undefined,
  'POLL_AUCTIONS_GET_LIVE_SUCCESS': (data) => ({ data }),
  'POLL_AUCTIONS_GET_LIVE_ERROR': (error) => ({ error }),

  'AUCTIONS_GET_ALL_START': undefined,
  'AUCTIONS_GET_ALL_SUCCESS': (data) => ({ data }),
  'AUCTIONS_GET_ALL_ERROR': (error) => ({ error }),

  'POLL_AUCTIONS_GET_ALL_START': undefined,
  'POLL_AUCTIONS_GET_ALL_SUCCESS': (data) => ({ data }),
  'POLL_AUCTIONS_GET_ALL_ERROR': (error) => ({ error }),

  'MY_AUCTIONS_GET_START': undefined,
  'MY_AUCTIONS_GET_SUCCESS': (data) => ({ data }),
  'MY_AUCTIONS_GET_ERROR': (error) => ({ error }),

  'POLL_MY_AUCTIONS_GET_START': undefined,
  'POLL_MY_AUCTIONS_GET_SUCCESS': (data) => ({ data }),
  'POLL_MY_AUCTIONS_GET_ERROR': (error) => ({ error }),

  'BID_ON_AUCTION_START': undefined,
  'BID_ON_AUCTION_SUCCESS': (data) => ({ data }),
  'BID_ON_AUCTION_ERROR': (error) => ({ error }),

  'AUCTION_FINALIZE_START': undefined,
  'AUCTION_FINALIZE_SUCCESS': (data) => ({ data }),
  'AUCTION_FINALIZE_ERROR': (error) => ({ error }),

  'MY_TEAMS_GET_START': undefined,
  'MY_TEAMS_GET_SUCCESS': (data) => ({ data }),
  'MY_TEAMS_GET_ERROR': (error) => ({ error }),

  'POLL_MY_TEAMS_GET_START': undefined,
  'POLL_MY_TEAMS_GET_SUCCESS': (data) => ({ data }),
  'POLL_MY_TEAMS_GET_ERROR': (error) => ({ error }),

  'GET_UNCLAIMED_BIDS_BY_AUCTION_INDEX_BY_BIDDER_START': undefined,
  'GET_UNCLAIMED_BIDS_BY_AUCTION_INDEX_BY_BIDDER_SUCCESS': (data) => ({ data }),
  'GET_UNCLAIMED_BIDS_BY_AUCTION_INDEX_BY_BIDDER_ERROR': (error) => ({ error }),

  'UNCLAIMED_BIDS_GET_ALL_START': undefined,
  'UNCLAIMED_BIDS_GET_ALL_SUCCESS': (data) => ({ data }),
  'UNCLAIMED_BIDS_GET_ALL_ERROR': (error) => ({ error }),

  'RETURN_BIDS_START': undefined,
  'RETURN_BIDS_SUCCESS': (data) => ({ data }),
  'RETURN_BIDS_ERROR': (error) => ({ error }),

  'POLL_UNCLAIMED_BIDS_GET_ALL_START': undefined,
  'POLL_UNCLAIMED_BIDS_GET_ALL_SUCCESS': (data) => ({ data }),
  'POLL_UNCLAIMED_BIDS_GET_ALL_ERROR': (error) => ({ error }),

});

const web3 = handleActions({

  [loadWeb3Success]: (state, { payload: { web3 }}) => ({
    ...state,
    provider: web3,
  }),

  [loadWeb3AccountsSuccess]: (state, { payload: { accounts }}) => ({
    ...state,
    accounts,
  }),

  [updateBlockNumberSuccess]: (state, { payload: { blockNumber }}) => ({
    ...state,
    blockNumber,
  }),

  [loadNetworksSuccess]: (state, { payload: { netId }}) => ({
    ...state,
    feedbagUrl: FEEDBAG_URLS[netId],
    ipfsUrl: IPFS_URLS[netId],
    ethNetwork: ETH_NETWORK[netId],
  }),

}, {
  accounts: [],
  blockNunber: 0,
  feedbagUrl: '',
  ipfsUrl: '',
  ethNetwork: '',
  provider: false,
});

const token = handleActions({

  [tokenGetNameSuccess]: (state, { payload: { data }}) => ({
    ...state,
    name: data,
  }),

  [tokenGetSymbolSuccess]: (state, { payload: { data }}) => ({
    ...state,
    symbol: data,
  }),

}, {
  name: '...............',
  symbol: '....',
});

const tokenMetadata = handleActions({

  [tokenGetMetadataSuccess]: (state, { payload: { path, data }}) => ({
    ...state,
    paths: {
      ...state.paths,
      [path]: data,
    }
  }),

  [tokenGetMetadataPathSuccess]: (state, { payload: { resp }}) => ({
    ...state,
    path: resp.data,
  }),

  [tokenGetMetadataManifestSuccess]: (state, { payload: { data }}) => ({
    ...state,
    manifest: data,
  }),

}, {
  path: '',
  paths: {},
  manifest: {},
});

const createLegendaryAuctionForm = handleActions({

  [legendaryAuctionCreateStart]: (state) => ({
    ...state,
    error: '',
    success: false,
    tx: null,
  }),

  [legendaryAuctionCreateSuccess]: (state, { payload: { resp }}) => ({
    ...state,
    error: '',
    success: true,
    tx: resp.data.tx,
  }),

  [legendaryAuctionCreateError]: (state, { payload: { error }}) => ({
    ...state,
    success: false,
    error,
  }),

}, {
  error: '',
  success: false,
  tx: null,
});

const createRareAuctionForm = handleActions({

  [rareAuctionCreateStart]: (state) => ({
    ...state,
    error: '',
    success: false,
    tx: null,
  }),

  [rareAuctionCreateSuccess]: (state, { payload: { resp }}) => ({
    ...state,
    error: '',
    success: true,
    tx: resp.data.tx,
  }),

  [rareAuctionCreateError]: (state, { payload: { error }}) => ({
    ...state,
    success: false,
    error,
  }),

}, {
  error: '',
  success: false,
  tx: null,
});

const createCommonAuctionForm = handleActions({

  [commonAuctionCreateStart]: (state) => ({
    ...state,
    error: '',
    success: false,
    tx: null,
  }),

  [commonAuctionCreateSuccess]: (state, { payload: { resp }}) => ({
    ...state,
    error: '',
    success: true,
    tx: resp.data.tx,
  }),

  [commonAuctionCreateError]: (state, { payload: { error }}) => ({
    ...state,
    success: false,
    error,
  }),

}, {
  error: '',
  success: false,
  tx: null,
});

const reindexForm = handleActions({

  [reindexAuctionsStart]: (state) => ({
    ...state,
    error: '',
    success: false,
    hash: null,
  }),

  [reindexAuctionsSuccess]: (state, { payload: { data }}) => ({
    ...state,
    error: '',
    success: true,
    hash: data.ipfsHash,
  }),

  [reindexAuctionsError]: (state, { payload: { error }}) => ({
    ...state,
    success: false,
    error,
  }),

  [reindexLiveAuctionsStart]: (state) => ({
    ...state,
    error: '',
    success: false,
    hash: null,
  }),

  [reindexLiveAuctionsSuccess]: (state, { payload: { data }}) => ({
    ...state,
    error: '',
    success: true,
    hash: data.ipfsHash,
  }),

  [reindexLiveAuctionsError]: (state, { payload: { error }}) => ({
    ...state,
    success: false,
    error,
  }),

}, {
  error: '',
  success: false,
  hash: null,
});

const auctions = handleActions({

  [auctionsGetLiveSuccess]: (state, { payload: { data }}) => ({
    ...state,
    live: data,
  }),

  [pollAuctionsGetLiveSuccess]: (state, { payload: { data }}) => ({
    ...state,
    live: data,
  }),

  [auctionsGetAllSuccess]: (state, { payload: { data }}) => ({
    ...state,
    all: data,
  }),

  [pollAuctionsGetAllSuccess]: (state, { payload: { data }}) => ({
    ...state,
    all: data,
  }),

}, {
  live: [],
  all: [],
});

const myAuctions = handleActions({

  [myAuctionsGetSuccess]: (state, { payload: { data }}) => ({
    ...state,
    ...data,
  }),

  [pollMyAuctionsGetSuccess]: (state, { payload: { data }}) => ({
    ...state,
    ...data,
  }),

}, {
  winning: [],
  losing: [],
  unclaimedWon: [],
  unclaimedLost: [],
});

const myTeams = handleActions({

  [myTeamsGetSuccess]: (state, { payload: { data }}) => {

    let tokensByTeam = {};
    data.forEach(token => {
      let teamName = token.attributes[1].value;
      if (!tokensByTeam[teamName]) {
        tokensByTeam[teamName] = [];
      }
      tokensByTeam[teamName].push(token);
    });

    let uniqueCountByTeam = {};
    Object.keys(tokensByTeam).forEach(teamName => {
      let playerIds = tokensByTeam[teamName].map(token => token.playerId);
      uniqueCountByTeam[teamName] = [...new Set(playerIds)].length;
    });

    return {
      ...state,
      tokens: data,
      tokensByTeam,
      uniqueCountByTeam,
    };
  },

  [pollMyTeamsGetSuccess]: (state, { payload: { data }}) => {

    let tokensByTeam = {};
    data.forEach(token => {
      let teamName = token.attributes[1].value;
      if (!tokensByTeam[teamName]) {
        tokensByTeam[teamName] = [];
      }
      tokensByTeam[teamName].push(token);
    });

    let uniqueCountByTeam = {};
    Object.keys(tokensByTeam).forEach(teamName => {
      let playerIds = tokensByTeam[teamName].map(token => token.playerId);
      uniqueCountByTeam[teamName] = [...new Set(playerIds)].length;
    });

    return {
      ...state,
      tokens: data,
      tokensByTeam,
      uniqueCountByTeam,
    };
  },

}, {
  tokens: [],
  tokensByTeam: {},
  uniqueCountByTeam: {},
  colors: TEAM_COLORS,
});

const unclaimedBids = handleActions({

  [unclaimedBidsGetAllSuccess]: (state, { payload: { data }}) => ({
    ...state,
    all: data,
  }),

  [pollUnclaimedBidsGetAllSuccess]: (state, { payload: { data }}) => ({
    ...state,
    all: data,
  }),

}, {
  all: {},
});

const rootReducer = combineReducers({
  router: routerReducer,
  web3,
  token,
  tokenMetadata,
  createLegendaryAuctionForm,
  createRareAuctionForm,
  createCommonAuctionForm,
  reindexForm,
  auctions,
  myAuctions,
  myTeams,
  unclaimedBids,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/util/redux.js